import { internalGetMemberAccessSummary } from '@gonfalon/openapi/operations/internalGetMemberAccessSummary';
import { internalGetTeamAccessSummary } from '@gonfalon/openapi/operations/internalGetTeamAccessSummary';
import { internalPostAccessSummaryPreview } from '@gonfalon/openapi/operations/internalPostAccessSummaryPreview';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getMemberAccessSummaryQuery = createQueryOptions(internalGetMemberAccessSummary);
export const getTeamAccessSummaryQuery = createQueryOptions(internalGetTeamAccessSummary);
export const getAccessSummaryPreviewQuery = createQueryOptions(internalPostAccessSummaryPreview);
